import { render, staticRenderFns } from "./UnitHero.vue?vue&type=template&id=56d7864b&scoped=true"
import script from "./UnitHero.vue?vue&type=script&lang=js"
export * from "./UnitHero.vue?vue&type=script&lang=js"
import style0 from "./UnitHero.vue?vue&type=style&index=0&id=56d7864b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d7864b",
  null
  
)

export default component.exports